"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningItemReportApi = exports.PlanningItemReportApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * PlanningItemReportApi - axios parameter creator
 * @export
 */
const PlanningItemReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} planningItemReportId
         * @param {RequestPlanningItemReportUpdate} requestPlanningItemReportUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItemReport: async (planningItemReportId, requestPlanningItemReportUpdate, options = {}) => {
            // verify required parameter 'planningItemReportId' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemReport', 'planningItemReportId', planningItemReportId);
            // verify required parameter 'requestPlanningItemReportUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemReport', 'requestPlanningItemReportUpdate', requestPlanningItemReportUpdate);
            const localVarPath = `/api/planning-item/report/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemReportId !== undefined) {
                localVarQueryParameter['planningItemReportId'] = planningItemReportId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemReportUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PlanningItemReportApiAxiosParamCreator = PlanningItemReportApiAxiosParamCreator;
/**
 * PlanningItemReportApi -
 */
var PlanningItemReportApi;
(function (PlanningItemReportApi) {
    /**
     *
     * @param {number} planningItemReportId
     * @param {RequestPlanningItemReportUpdate} requestPlanningItemReportUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemReportApi
     * url /api/planning-item/report/update
     */
    async function updatePlanningItemReport(planningItemReportId, requestPlanningItemReportUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemReportApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItemReport(planningItemReportId, requestPlanningItemReportUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIPlanningItemReportEntity)(res.data);
            return res;
        });
    }
    PlanningItemReportApi.updatePlanningItemReport = updatePlanningItemReport;
})(PlanningItemReportApi || (exports.PlanningItemReportApi = PlanningItemReportApi = {}));
